export const navTitle = {'en': 'HealthVaani',
    'hi': 'हेल्थवाणी',
    'or': 'ହେଲଥବାଣୀ',
    'mr': 'हेल्थवाणी'
}